import {getCurrentYear} from '../../utils/commons'
import BestSportsGearPicksLogo from './logo'
import {bestSportsGearPicksStyles} from './styles'

const baseConfig = {
  domainName: 'bestsportsgearpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Sports Gear Picks',
  logo: <BestSportsGearPicksLogo className="size-12 shrink-0 tablet:size-10" />,
  favicon: '/favicons/bestsportsgearpicks.png',
  styles: bestSportsGearPicksStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-Q0WL3MQ8JF',
    camelCaseUrl: 'BestSportsGearPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestSportsGearPicks.com - Pro Reviews & Buying Guides`,
    description: (_category?: string, count?: string) =>
      `Discover the top sports gear with BestSportsGearPicks.com. Our expert team curates comprehensive top ${count} lists, in-depth reviews, and detailed specs to help you gear up for peak performance.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
